module.exports = __webpack_public_path__ + "img/gmail-select-signature.4a214eb4.png";